
<div class="tab-component">
  <div class="tab-component-wrapper">
    <div class="tab-title">
      <h3>Engineering</h3>
    </div>

    <div class="tab-content">

      <div class="aggrid-criteria">
        <div class="grid-filter-criteria">
          <div>
            <label class="col-form-label me-3">Event Type</label>
            <select class="custom-dropdown mb-2" (change)="selectEventType($event)">
              <option selected>All</option>
              <option value="1">Provision Success</option>
              <option value="2">Provision	Failed</option>
              <option value="3">Install	In Progress</option>
              <option value="4">Install Success</option>
              <option value="5">Install Failed</option>
              <option value="10">Created Success</option>
              <option value="7">Updated	Success</option>
              <option value="8">Deleted	Success</option>
              <option value="9">UnInstalled	Success</option>
              <option value="6">Record Created Success</option>
              <option value="16">ESIM Status Success</option>
              <option value="15">ESIM Status Failed</option>
              <!-- <option value="10">Created Success</option> -->
            </select>
          </div>

        </div>

        <!-- <div class="grid-download-csv">
            <button class="button-download">
              <span class="button-icon"><mat-icon>cloud_download</mat-icon></span>
              <span class="button-text">DOWNLOAD</span>
            </button>
        </div> -->
      </div>

        <div class="tab-content-wrapper content-wrapper-aggrid">
          <div class="component-ag-grid-wrapper audit-history-grid"
            [style.--mc-ag-page-size]="gridLayoutRowCount"
            [style.--mc-ag-host-height.px]="gridHostHeightPx"
            (contextmenu)="preventDefaultContextMenu($event)" mcAgGridCopyCellTooltip style="position: relative;">
            <ag-grid-angular
            class="ag-theme-alpine"
              [rowModelType]="'infinite'"
              [domLayout]="'normal'"
              [columnDefs]="columnDefs"
              [defaultColDef]="defaultColDef"
              [datasource]="dataSource"
              (gridReady)="onGridReady($event)"
              (sortChanged)="onSortChanged($event)"
              [pagination]="true"
              [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="pageSizeOptions"
              [cacheBlockSize]="paginationPageSize"
              [maxBlocksInCache]="1"
              [maxConcurrentDatasourceRequests]="1"
              (paginationChanged)="onPaginationChanged($event)"
              [gridOptions]="gridOptions"
              (cellContextMenu)="onCellContextMenu($event)">
            </ag-grid-angular>
            <div class="custom-context-menu" *ngIf="contextMenu.visible" [ngStyle]="{'top.px': contextMenu.y, 'left.px': contextMenu.x}">
              <ul>
              <li (click)="copyToClipboard(contextMenu.value)">Copy Value</li>
              </ul>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>


